import { z } from 'zod';
import { zStringRequired } from '../../z';
export const ptPlanOfCareValidationSchema = z.object({
    id: z.string().optional(),
    data: z.object({
        treatmentPlan: z.object({
            ptEval: z.string().optional(),
            patientAgrees: z.boolean().optional(),
            patientAgreesTo: z.string().optional(),
        }),
        rehabUpperExt: z.object({
            na: z.boolean().optional(),
            left: z.array(z.string()).optional(),
            right: z.array(z.string()).optional(),
        }),
        rehabLowerExt: z.object({
            na: z.boolean().optional(),
            left: z.array(z.string()).optional(),
            right: z.array(z.string()).optional(),
        }),
        therapyExercise: z.object({
            na: z.boolean().optional(),
            exercises: z.array(z.string()).optional(),
            prom: z.array(z.string()).optional(),
            aarom: z.array(z.string()).optional(),
            arom: z.array(z.string()).optional(),
            isom: z.array(z.string()).optional(),
            pre: z.array(z.string()).optional(),
            trunk: z.array(z.string()).optional(),
        }),
        bodyExercise: z.object({
            lue: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            lle: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            rue: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            rle: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
        }),
        cardiopulmonary: z.object({
            na: z.boolean().optional(),
            tolerance: z.string().optional(),
            activity: z.array(z.string()).optional(),
            monitor: z.array(z.string()).optional(),
            orders: z.array(z.string()).optional(),
            ordersFollow: z.string().optional(),
            breathingExercises: z.array(z.string()).optional(),
            energyTechnique: z.array(z.string()).optional(),
        }),
        painManagement: z.object({
            na: z.boolean().optional(),
            painManagement: z.array(z.string()).optional(),
        }),
        functionalActivities: z.object({
            na: z.boolean().optional(),
            functionalActivities: z.array(z.string()).optional(),
        }),
        adliadl: z.object({
            na: z.boolean().optional(),
            safeTechnique: z.array(z.string()).optional(),
            compensatoryTechnique: z.array(z.string()).optional(),
            adaptiveTechnique: z.array(z.string()).optional(),
            activities: z.array(z.string()).optional(),
            activitiesOther: z.string().optional(),
        }),
        bedMobility: z.object({
            na: z.boolean().optional(),
            bedMobility: z.array(z.string()).optional(),
        }),
        manualTherapy: z.object({
            na: z.boolean().optional(),
            manualTherapy: z.array(z.string()).optional(),
        }),
        gait: z.object({
            na: z.boolean().optional(),
            training: z.array(z.string()).optional(),
            sequencing: z.string().optional(),
            assistiveDevice: z.string().optional(),
            cadence: z.string().optional(),
            surfaces: z.string().optional(),
            baseSupport: z.string().optional(),
            wb: z.string().optional(),
            wbIndicate: z.array(z.string()).optional(),
        }),
        transfers: z.object({
            na: z.boolean().optional(),
            notes: z.string().optional(),
            from: z.array(z.string()).optional(),
            fromProperTechnique: z.string().optional(),
            fromOther: z.string().optional(),
        }),
        balanceTransfer: z.object({
            na: z.boolean().optional(),
            balanceTransfer: z.array(z.string()).optional(),
        }),
        ptcgEducation: z.object({
            na: z.boolean().optional(),
            ptcgEducation: z.array(z.string()).optional(),
        }),
        frequencyOfVisits: z.object({
            noOfVisits: z.string().optional(),
            recurring: z.string().optional(),
            duration: z.string().optional(),
            otherDisciplineRecommend: z.array(z.string()).optional(),
            patientShowImprovement: z.string(),
        }),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
